import React, { useRef, useState } from 'react';
import DigitInput from './components/DigitInput';
import './App.css';
import lockImg from './images/lock.webp';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import ThingsPage from './ThingsPage';
import PuzzlePage from './PuzzlePage';
import PhotoGallery from './PhotoGallery';
import SurprisePage from './SurprisePage';
import VideoUpload from './VideoUpload';
import BalloonGame from './BalloonGame';
import WishPage from './WishPage';
import { AudioProvider, useAudio } from './AudioContext';

const PASSWORD = '200225';

function LockPage() {
  const [digits, setDigits] = useState(Array(6).fill(''));
  const [feedback, setFeedback] = useState(null); // 'success' | 'error' | null
  const [focused, setFocused] = useState(0);
  const navigate = useNavigate();
  const { playSound1 } = useAudio();
  const hasStartedAudio = React.useRef(false);

  // Try to play audio on first user interaction
  React.useEffect(() => {
    const handleFirstInteraction = () => {
      if (!hasStartedAudio.current) {
        playSound1();
        hasStartedAudio.current = true;
      }
    };

    // Listen for various user interactions
    const events = ['click', 'keydown', 'touchstart', 'mousedown'];
    events.forEach(event => {
      document.addEventListener(event, handleFirstInteraction, { once: true });
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleFirstInteraction);
      });
    };
  }, [playSound1]);

  // Also try to play when user starts typing
  const handleDigitChange = (idx, val) => {
    if (!hasStartedAudio.current) {
      playSound1();
      hasStartedAudio.current = true;
    }
    if (!/^\d?$/.test(val)) return;
    const copy = digits.slice();
    copy[idx] = val;
    setDigits(copy);
    setFeedback(null);
    if (val && idx < 5) setFocused(idx + 1);
    if (copy.every(v => v.length === 1)) {
      if (copy.join('') === PASSWORD) setFeedback('success');
      else setFeedback('error');
    }
  };

  React.useEffect(() => {
    if (feedback === 'success') {
      setTimeout(() => navigate('/things'), 1000);
    }
  }, [feedback, navigate]);


  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      if (digits[idx]) {
        handleDigitChange(idx, '');
      } else if (idx > 0) {
        setFocused(idx - 1);
        handleDigitChange(idx - 1, '');
      }
    } else if (e.key === 'ArrowLeft' && idx > 0) {
      setFocused(idx - 1);
    } else if (e.key === 'ArrowRight' && idx < 5) {
      setFocused(idx + 1);
    } else if (/^\d$/.test(e.key)) {
      e.preventDefault();
      handleDigitChange(idx, e.key);
    }
  };

  return (
    <div className="bg-animated">
      <div className="main-container">
        <form autoComplete="off" className="digit-form" onSubmit={e => e.preventDefault()}>
          <div className={"digit-row " + (feedback ? feedback : "") }>
            {digits.map((val,i) => (
              <DigitInput
                key={i}
                value={val}
                onChange={v => handleDigitChange(i, v)}
                focused={focused === i}
                isSuccess={feedback === 'success'}
                isError={feedback === 'error'}
                onKeyDown={e => handleKeyDown(i, e)}
              />
            ))}
          </div>
        </form>
        <div className="image-box">
          <img
            src={lockImg}
            alt="Surprise birthday"
            className="main-image"
            draggable={false}
          />
        </div>
        <div className={
          'feedback-bubble ' +
          (feedback === 'success' ? 'feedback-success' : feedback === 'error' ? 'feedback-error' : '')
        }>
          {feedback === 'success' && <>
            <span>yeyyy! bener🫶🏻</span>
          </>}
          {feedback === 'error' && <>
            <span>ih salah, badmood😠</span>
          </>}
        </div>
      </div>
    </div>
  );
}

export default function AppRouter() {
  return (
    <AudioProvider>
      <BrowserRouter future={{ v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<LockPage />} />
          <Route path="/things" element={<ThingsPage />} />
          <Route path="/puzzle" element={<PuzzlePage />} />
          <Route path="/surprise" element={<SurprisePage />} />
          <Route path="/upload-video/:category" element={<VideoUpload />} />
          <Route path="/balloon" element={<BalloonGame />} />
          <Route path="/admin" element={<PhotoGallery />} />
          <Route path="/wish" element={<WishPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AudioProvider>
  );
}
